import React from "react";
import { Link } from "react-router-dom";
import '../styles/Navbar.css';
import '../styles/global.css';

function Navbar() {
    return (
    <div className="navbar">
      <Link className="nav-link" to="/">
        Home
      </Link>
      <Link className="nav-link" to="/instructions">
        Instructions
      </Link>
    </div>
    );
}

export default Navbar;